import axios from "axios";
import { API_AUTH } from "../constants";
import { logOut, setAuthUser } from "../../store/authReducer";
import { store } from "../../store";

const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

interface AuthResponse {
    token?: string;
    tokenType?: string;
    username?: string;
    userType?: string;
    projects?: boolean;
    privileges?: string[];
    roles?: string[];
    status?: number;
    errorCode?: string | null;
    message?: string;
}

interface MenuItem {
    id: string;
    text: string;
    icon: string;
    href: string;
    visible: boolean;
    children?: MenuItem[];
}

class AuthService {
    private items: MenuItem[] = [
        { id: "1", text: "Dashboard", icon: "grid", href: "./dashboard", visible: true },
        { id: "2", text: "Prompt Library", icon: "portfolios", href: "./prompt", visible: true },
        { id: "3", text: "Run Document", icon: "upload-line", href: "./rundocument", visible: true },
        { id: "4", text: "Bulk Prompt Run", icon: "folder-stack", href: "./multi-run-prompt", visible: true },
        { id: "5", text: "Validation Library", icon: "list-bullet-square", href: "./validationrule", visible: true },
        { id: "6", text: "Smart Prompt Builder", icon: "book-page", href: "./smartprompt", visible: true },
        { id: "7", text: "Interactive Prompt Builder", icon: "chat-box", href: "./chat", visible: true },
    ];

    constructor() { }

    // Login method
    public async login(idToken: any): Promise<AuthResponse> {
        try {
            const res = await axios.post(`${API_BASE_URL}${API_AUTH.LOGIN}`, null, {
                headers: {
                    'AZ-Authorization': `Bearer ${idToken}`,
                },
            });
            if (res.data && res.data.token) {
                store.dispatch(setAuthUser({ ...res.data }));
            }
            return res.data;
        } catch (error) {
            throw new Error("Login failed");
        }
    }

    // Logout method
    public logout(navigate: Function, instance: any): void {
        store.dispatch(logOut());
        instance.logoutRedirect();
        navigate("/");
    }

    // Authorize menu items based on user permissions (visibility)
    public privilegeItems(): MenuItem[] {
        const filteredItems = this.items
            .map((item: MenuItem) => ({
                ...item,
                children: item.children ? item.children.filter((child: MenuItem) => child.visible) : []
            }))
            .filter((item: MenuItem) => item.visible);

        const itms = JSON.parse(JSON.stringify(filteredItems));

        if (itms.length > 0) return itms;
        else return [{ id: "0", text: "", icon: "", href: "./not-authorized", visible: true }];
    }

    public hasPrivilege(privilege: string): boolean {
        const state = store.getState();
        const privileges = state.auth.authUser?.privileges;
        return privileges ? privileges.includes(privilege) : false;
    }

    public async refreshToken(): Promise<any> {
        const state = store.getState();
        const token = state.auth.authToken;
        if (!token) {
            return null;
        }
        try {
            const res = await axios.get(`${API_BASE_URL}${API_AUTH.REFRESH}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            store.dispatch(setAuthUser({ ...res.data }));
            return res.data;
        } catch (err) {
            return null;
        }
    }
}

export default new AuthService();
